import { render, staticRenderFns } from "./mermaidUser.vue?vue&type=template&id=4c649f24&scoped=true&"
import script from "./mermaidUser.vue?vue&type=script&lang=js&"
export * from "./mermaidUser.vue?vue&type=script&lang=js&"
import style0 from "./mermaidUser.vue?vue&type=style&index=0&id=4c649f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c649f24",
  null
  
)

export default component.exports